<template>
  <div class="flex flex-col  px-2 py-4 rounded-2xl bg-blue-300 shadow-md m-1">
    <label>{{ label }}</label>
    <toggle-button
      class="bg-red-500"
      :value="element.visible"
      :name="''"
      @toggle="this.$emit('toggle')"
      :disabled_name="$t('control.disabled')"
      :enabled_name="$t('control.enabled')"
    />
    <input
      type="text"
      v-model="element.url"
      class="my-1 text-center rounded-full"
      :placeholder="'myhotspot.mt / 10.0.0.1'"
    />
    <div class="flex items-center" v-if="designer == 'advanced'">
      <p>U</p>
      <input
        type="range"
        min="0"
        max="90"
        class="appearance-none rounded-full h-2 bg-gray-100 w-full"
        v-model="element.y"
      />
      <p>D</p>
    </div>
    <div class="flex items-center" v-if="designer == 'advanced'">
      <p>L</p>
      <input
        type="range"
        min="0"
        max="90"
        class="appearance-none rounded-full h-2 bg-gray-100 w-full"
        v-model="element.x"
      />
      <p>R</p>
    </div>
    <div class="flex items-center" v-if="designer == 'advanced'">
      <p>S</p>
      <input
        type="range"
        min="50"
        max="120"
        class="appearance-none rounded-full h-2 bg-gray-100 w-full"
        v-model="element.size"
      />
      <p>L</p>
    </div>
  </div>
</template>
<script>
import ToggleButton from "../formElements/ToggleButton.vue";
export default {
  name: "PrintCardsDesignerQr",
  props: ["element", "label", "designer"],
  components: { ToggleButton },
};
</script>
